import { HomeMinusOutlineIcon } from './HomeMinusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8DB9C230-99DF-4137-9A32-2D1058D824EA
 * name home-minus-outline
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-minus-outline.svg
 * tags
 * - Home Automation 
 */
export const HouseMinusOutlineIcon = HomeMinusOutlineIcon;
export default HouseMinusOutlineIcon